import store from '../store/store';

export const loadOnStart = async () => {
  await store.dispatch('randomizeId');
  return store.dispatch('reloadBanks');
}

export const loadOnLogin = async () => {
  // await store.dispatch('reloadAgreements')
  await store.dispatch('reloadClauses');
}
